import script from "./staff.vue?vue&type=script&setup=true&lang=js"
export * from "./staff.vue?vue&type=script&setup=true&lang=js"

import "./staff.vue?vue&type=style&index=0&id=981a7198&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-981a7198"]])

export default __exports__